import React, { Component } from 'react';

import classes from './ArticleSectionHeader.scss';

export default class ArticleSectionHeader extends Component {
  render() {
    return (
      <h2 className={classes.header}>{this.props.children}</h2>
    );
  }
}
